import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastConfig {
  timeOut?: number;
  disableTimeOut?: boolean;
}

export interface ToastMessage {
  id: number;
  type: 'success' | 'error';
  message: string;
}

@Injectable()
export class MessageService {
  private readonly toastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  readonly toasts$ = this.toastsSubject.asObservable();
  private nextId = 0;
  private readonly timeouts = new Map<number, ReturnType<typeof setTimeout>>();

  showSuccess(message: string, config: ToastConfig = { timeOut: 5000, disableTimeOut: true }) {
    if (!message?.trim()) {
      return;
    }
    this.addToast('success', message, config);
  }

  showError(message: string, config: ToastConfig = { disableTimeOut: true }) {
    if (message && !['Unauthenticated.'].includes(message)) {
      this.addToast('error', message, config);
    }
  }

  hideAllMessage() {
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts.clear();
    this.toastsSubject.next([]);
  }

  dismiss(id: number) {
    const timeout = this.timeouts.get(id);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(id);
    }
    this.toastsSubject.next(this.toastsSubject.value.filter((toast) => toast.id !== id));
  }

  private addToast(type: 'success' | 'error', message: string, config: ToastConfig) {
    const toasts = this.toastsSubject.value;
    if (toasts.some((toast) => toast.type === type && toast.message === message)) {
      return;
    }

    const id = ++this.nextId;
    this.toastsSubject.next([...toasts, { id, type, message }]);

    if (!config.disableTimeOut && config.timeOut) {
      const timeout = setTimeout(() => this.dismiss(id), config.timeOut);
      this.timeouts.set(id, timeout);
    }
  }
}
